/** @format */

import NewHireActionTypes from './new-hire.types';

const INITIAL_STATE = {
  data: null,
  error: null,
  departmentTailNumberMapping: {
    Accounting: '6100',
    ACE: '1330',
    'Airport Services': '1205',
    'Buisness Development & Sales': '2100',
    Catering: '1210',
    'Customer Support': '1220',
    'DELUX Corporate': '000000',
    Engineering: '1320',
    'Executive VP & UP': '8100',
    Finance: '6010',
    'Flight Ops Admin': '1140',
    'Flight Technical': '1120',
    'Flight Training': '1125',
    Fuel: '6030',
    GSE: '1240',
    'Heavy Mx': '1325',
    'Help Desk': '7100',
    HR: '5200',
    Inflight: '1115',
    IT: '7500',
    'JSX Airport Services': '000154',
    'JSX Buisness Development': '000205',
    'JSX Commercial': '000601',
    'JSX Corporate Soul': '000326',
    'JSX Director of Operations': '000165',
    'JSX ERJ Fleet/Pilots': '000101',
    'JSX Executive Management': '000401',
    'JSX Finance Administration': '000301',
    'JSX Flight Attendants': '000120',
    'JSX  Flight Scheduling': '000158',
    'JSX Flight Training': '000151',
    'JSX Guest Services': '000226',
    'JSX IT': '000351',
    'JSX Maintenance': '000176',
    'JSX Maintenance Techs(ERJ)': '000171',
    'JSX Marketing': '000251',
    'JSX Mission Control': '000157',
    'JSX Rebrand': '000901',
    'JSX Safety': '000126',
    'JSX Sales': '000201',
    'JSX Tactical': '000231',
    'Learning and Development': '5400',
    'Maintenance Admin': '1310',
    'Maintenance Tech': '1305',
    Marketing: '4100',
    'Mission Control': '1405',
    'MX Controllers': '1335',
    'OCC Coordinators': '1415',
    'Operation Services': '1235',
    Pilots: '1105',
    Quality: '1350',
    Safety: '3100',
    Security: '3200',
    Strategy: '2300',
    'Supply Chain (Parts)': '1315',
    'Talent Acquisition': '5100',
    Valet: '1230',
    'JSX Chief Pilots': '000141',
  },
  expensePolicyGroupMapping: {
    'US - Corporate - FINANCE ONLY': 'US5',
    'US - Flight Crew - Pilots/FAs': 'US2',
    'US - Non-Flight Crew - Airport Staff': 'US7',
    'US - Non-Flight Crew - Corporate': 'US3',
    'US - Non-Flight Crew - Operations': 'US6',
  },
  invoiceGroupMapping: {
    'Airport Services': 'GPR3',
    'Corporate - Finance': 'GPR1',
    Marketing: 'GPR2',
    MX: 'GPR4',
    Soul: 'GPR5',
  },
  currDepartment: '',
  currPosition: '',

  firstName: '',
  lastName: '',
  hireDate: '',
  localDistros: [],
  googleGroups: null,
  azureGroups: null,
  noc: null,
  navitaire: null,
  uber: null,
  lyft: null,
  location: '',
};

const newhirereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NewHireActionTypes.GET_DATA_SUCCESS:
      return { ...state, error: null, data: action.payload };

    case NewHireActionTypes.GET_DATA_FAILURE:
      return { ...state, error: action.payload, data: null };

    case NewHireActionTypes.SET_CURR_DEPARTMENT:
    case NewHireActionTypes.CLEAR_CURR_DEPARTMENT:
      return { ...state, currDepartment: action.payload };

    case NewHireActionTypes.SET_CURR_POSITION:
    case NewHireActionTypes.CLEAR_CURR_POSITION:
      return { ...state, currPosition: action.payload };

    case NewHireActionTypes.SET_FIRST_NAME:
    case NewHireActionTypes.CLEAR_FIRST_NAME:
      return { ...state, firstName: action.payload };

    case NewHireActionTypes.SET_LAST_NAME:
    case NewHireActionTypes.CLEAR_LAST_NAME:
      return { ...state, lastName: action.payload };

    case NewHireActionTypes.SET_HIRE_DATE:
    case NewHireActionTypes.CLEAR_HIRE_DATE:
      return { ...state, hireDate: action.payload };

    case NewHireActionTypes.SET_LOCAL_DISTROS:
    case NewHireActionTypes.CLEAR_LOCAL_DISTROS:
      return { ...state, localDistros: action.payload };

    case NewHireActionTypes.SET_AZURE_GROUPS:
      return { ...state, azureGroups: action.payload };

    case NewHireActionTypes.SET_GOOGLE_GROUPS:
      return { ...state, googleGroups: action.payload };

    case NewHireActionTypes.SET_NOC:
      return { ...state, noc: action.payload };

    case NewHireActionTypes.SET_LOCATION:
      return { ...state, location: action.payload };

    case NewHireActionTypes.SET_NAVITAIRE:
      return { ...state, navitaire: action.payload };

    case NewHireActionTypes.SET_UBER:
      return { ...state, uber: action.payload };

    case NewHireActionTypes.SET_LYFT:
      return { ...state, lyft: action.payload };

    default:
      return state;
  }
};

export default newhirereducer;
